<template>
    <div>
        <common-table :url="url"
                      :table-columns="tableColumns"
                      :form-fields="formFields"
                      :operate="operate"
                      :permission="permission"
                      :searchs="searchs"
                      :buttons="buttons"
                      ref="table">
        </common-table>
        <div class="dialog">
            <el-dialog title="选择导出时间"
                       :visible.sync="exportVisible"
                       custom-class="common-dialog"
                       :close-on-click-modal="false"
                       @close="resetForm('form')"
                       width="30%">
                <div class="dialog_body">
                    <el-form label-position="right" status-icon label-width="90px"
                             :model="form" ref="form">
                        <el-form-item label="代理" prop="agentId" :rules="[{message: '请选择代理', trigger: 'blur', required: false}]">
                            <el-select filterable
                                       v-model="form.agentId" clearable
                                       placeholder="请选择代理"
                                       size="medium" class="mr10 mb-10">
                                <el-option v-for="(option, index) in agents" :key="index" :label="option.name" :value="option.id"/>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="开始时间" prop="startTime" :rules="[{message: '请选择开始时间', trigger: 'blur', required: true}]">
                            <el-date-picker v-model="form.startTime"
                                            placeholder="开始时间"
                                            value-format="yyyy-MM-dd HH:mm:ss"
                                            type='datetime' align="right"
                                            size="medium" class="mr10 mb-10"/>
                        </el-form-item>
                        <el-form-item label="结束时间" prop="endTime" :rules="[{message: '请选择结束时间', trigger: 'blur', required: true}]">
                            <el-date-picker v-model="form.endTime"
                                            placeholder="结束时间"
                                            value-format="yyyy-MM-dd HH:mm:ss"
                                            type='datetime' align="right"
                                            size="medium" class="mr10 mb-10"/>
                        </el-form-item>
                    </el-form>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button size="small" @click="exportVisible = false">取 消</el-button>
                    <el-button type="primary" size="small" @click="submit('form')">确 定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import CommonTable from "@/components/CommonTable/CommonTable";
    import request from  "@/utils/axios.js";
    import message from "../../utils/message";
    //import {excelDownload} from "../../utils/download";

    export default {
        name: "AgentRecharge",
        components: {CommonTable},
        data(){
            return{
                exportVisible: false,
                form: {
                    startTime: '',
                    endTime: '',
                    agentId: '',
                },
                agents: [],
                searchs:[
                    {
                        name: 'agentId',
                        placeholder: '代理',
                        type: 'select',
                        selectUrl: '/agent/getAll',
                        selectData: [],
                    },
                    {
                        name: 'orderNo',
                        placeholder: '充值订单号',
                        type: 'input'
                    },
                    /*{
                        name: 'payName',
                        placeholder: '付款人姓名',
                        type: 'input'
                    },
                    {
                        name: 'payeeName',
                        placeholder: '收款人姓名',
                        type: 'input'
                    },*/
                    {
                        name: 'status',
                        placeholder: '状态',
                        type: 'select',
                        selectValue:[{
                            key: 0,
                            value: '失败'
                        },{
                            key: 1,
                            value: '成功'
                        },{
                            key: 2,
                            value: '审核中'
                        }]
                    },
                    {
                        name: 'mode',
                        placeholder: '方式',
                        type: 'select',
                        selectValue:[{
                            key: 1,
                            value: '后台添加'
                        },{
                            key: 2,
                            value: '代理充值'
                        }]
                    },
                    {
                        name: 'startTime',
                        placeholder: '开始时间',
                        type: 'dateTime'
                    },
                    {
                        name: 'endTime',
                        placeholder: '结束时间',
                        type: 'dateTime'
                    }
                ],
                permission:{
                    //add: 'agentRecharge:add',
                    //update: 'agentRecharge:update',
                    //delete: 'agentRecharge:delete',
                    //deleteBatch: 'agentRecharge:deleteBatch'
                },
                url: {
                    get: '/agentRecharge/listByCondition',
                    //add: '/agentRecharge/add',
                    //update: '/agentRecharge/update',
                    //delete: '/agentRecharge/delete/',
                    //delete_batch: '/agentRecharge/deleteBatch',
                },
                tableColumns: [{
                    field: 'id',
                    label: 'ID',
                    show: true,
                    detail: true,
                    width: '',
                }, {
                    field: 'agentId',
                    label: '代理',
                    selectUrl: '/agent/getAll',
                    selectData: [],
                    show: {
                        type: 'select',
                    },
                    detail: false,
                    width: '',
                },{
                    field: 'orderNo',
                    label: '订单号',
                    show: true,
                    detail: true,
                    width: '',
                },{
                    field: 'outOrderNo',
                    label: '交易ID',
                    show: true,
                    detail: true,
                    width: '',
                },{
                    field: 'fromAddress',
                    label: '出款地址',
                    show: true,
                    width: '',
                },{
                    field: 'toAddress',
                    label: '收款地址',
                    show: true,
                    detail: true,
                    width: '',
                },{
                    field: 'amount',
                    label: '金额(USDT)',
                    show: true,
                    detail: true,
                    width: '',
                },{
                    field: 'status',
                    label: '状态',
                    show: {
                        type: 'tag',
                        tags: [{
                            key: 0,
                            value: '失败',
                            type: 'danger'
                        },{
                            key: 1,
                            value: '成功',
                            type: 'success'
                        },{
                            key: 2,
                            value: '审核中',
                            type: 'info'
                        }]
                    },
                    detail: false,
                    width: '',

                },{
                    field: 'mode',
                    label: '方式',
                    show: {
                        type: 'tag',
                        tags: [{
                            key: 1,
                            value: '后台添加',
                            type: 'warning'
                        },{
                            key: 2,
                            value: '代理充值',
                            type: 'primary'
                        }]
                    },
                    detail: false,
                    width: '',

                },{
                    field: 'expound',
                    label: '说明',
                    //show: true,
                    detail: true,
                    width: '',
                },{
                    field: 'confirmName',
                    label: '确认人',
                    //show: true,
                    detail: true,
                    width: '',
                },{
                    field: 'type',
                    label: '类型',
                    show: true,
                    detail: true,
                    width: '',
                }, {
                    field: 'createTime',
                    label: '充值时间',
                    show: true,
                    detail: true,
                    width: '',
                }],
                formFields: {
                    addTitle: '添加订单',
                    updateTitle: '修改订单',
                    model: [],
                },
                operate: [{
                    icon: 'el-icon-edit',
                    type: 'text',
                    text: '成功',
                    handle: (row) => {
                        if (row.status != 2){
                            message.warning("已审核，不可重复审核");
                            return;
                        }
                        request.post({
                            url: '/agentRecharge/audit',
                            data: {id: row.id, status : 1},
                            confirm: '确定审核通过？',
                            success: (data) => {
                                if (data.code == 0){
                                    message.success("操作成功");
                                    this.$refs.table.getData();
                                }else {
                                    message.error("操作失败");
                                }
                            }
                        });
                    }
                },{
                    icon: 'el-icon-edit',
                    type: 'text',
                    text: '失败',
                    handle: (row) => {
                        if (row.status != 2){
                            message.warning("已审核，不可重复审核");
                            return;
                        }
                        request.post({
                            url: '/agentRecharge/audit',
                            data: {id: row.id, status : 0},
                            confirm: '确定审核失败？',
                            success: (data) => {
                                if (data.code == 0){
                                    message.success("审核成功");
                                    this.$refs.table.getData();
                                }else {
                                    message.error("操作失败");
                                }
                            }
                        });
                    }
                }],
                buttons: [{
                    icon: 'el-icon-download',
                    type: 'warning',
                    text: '导出',
                    permission: 'agentRecharge:export',
                    click: () => {
                        this.tableColumns.some(item => {
                            if (item.field == 'agentId') {
                                this.agents = item.selectData;
                            }
                        })
                        this.exportVisible = true;
                    }
                }]
            }
        },
        methods: {
            //重置表单
            resetForm(formName){
                this.$refs[formName].resetFields();
            },
            submit(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        request.get({
                            url: '/agentRecharge/export',
                            data: this.form,
                            //responseType: 'arraybuffer',
                            confirm: '确定导出Excel？',
                            success: (res) => {
                                if (res.code === 0) {
                                    message.success("积分充值导出任务正在进行中");
                                    this.exportVisible = false;
                                } else {
                                    message.error(res.msg);
                                }
                                /*if (res.code) {
                                    message.error(res.msg);
                                    return;
                                }
                                excelDownload(res, "积分充值明细导出.xlsx");
                                /!*this.$msgbox({
                                    title: '下载地址',
                                    message: '下载地址为：' + res.data + '，点击确定跳转下载！'
                                }).then(() => {
                                    window.open(res.data,"_blank");
                                }).catch()*!/
                                this.exportVisible = false;*/
                            }
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>
